import { apiUrl } from 'util/apiUrl';
import { useQueries } from 'react-query';
import { useMatch } from 'react-router-dom';
import {
  ContentType,
  useAuthenticatedFetch,
} from 'hooks/util/useAuthenticatedFetch';

export const useAssessmentQueries = (
  ids: string[],
  contentType: ContentType,
) => {
  const fetch = useAuthenticatedFetch(contentType);
  const isShared = useMatch('/share/:linkId/:assessmentId');

  let enabled = true;
  if (!ids) {
    enabled = false;
  }
  if (isShared) {
    enabled = false;
  }
  return useQueries(
    ids.map((id) => {
      return {
        queryKey: ['assessments', id],
        queryFn: () =>
          fetch(`${apiUrl}/Assessments/${id}`),
        enabled,
      };
    }),
  );
};
